import { createSlice } from "@reduxjs/toolkit";
import { GetLensRunResponse, LensHit } from "Backend";
import { Block, DocumentIntakeBookmark } from "generated/graphql";
import RequestStatus from "../RequestStatus";
import { fetchBookmarks, fetchPageLensHits } from "./intakeViewer.action";

export function findLensHitFromBlock(hits: LensHit[], block: Block): LensHit | undefined {
  return hits.find((hit) => hit.block.index === block.index);
}

export interface IntakeViewerState {
  status: RequestStatus;
  documentSegments: {
    [documentSegmentId: number]: {
      [pageNumber: number]: {
        lensRun: GetLensRunResponse;
      };
    };
  };
  bookmarks: DocumentIntakeBookmark[];
}

const initialState: IntakeViewerState = {
  status: RequestStatus.IDLE,
  documentSegments: {},
  bookmarks: [],
};

const intakeViewerSlice = createSlice({
  name: "intakeviewer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPageLensHits.pending, (state) => {
        state.status = RequestStatus.PENDING;
      })
      .addCase(fetchPageLensHits.fulfilled, (state, { payload }) => {
        state.status = RequestStatus.SUCCEEDED;
        const foundDocumentSegmentCache = state.documentSegments[payload.documentSegmentId];
        const response = {
          hits: payload.hits,
          fullCountPreIdentity: payload.fullCountPreIdentity,
          fullCount: payload.fullCount,
        };
        if (foundDocumentSegmentCache) {
          state.documentSegments[payload.documentSegmentId] = {
            ...foundDocumentSegmentCache,
            [payload.pageNumber]: {
              lensRun: response,
            },
          };
        } else {
          state.documentSegments[payload.documentSegmentId] = {
            [payload.pageNumber]: {
              lensRun: response,
            },
          };
        }
      })
      .addCase(fetchPageLensHits.rejected, (state) => {
        state.status = RequestStatus.FAILED;
      })
      .addCase(fetchBookmarks.fulfilled, (state, { payload }) => {
        state.bookmarks = payload;
      });
  },
});

export default intakeViewerSlice;
